module.exports = __webpack_public_path__ + "img/unlock.a696cf79.svg";